import useSWR, { SWRConfiguration } from "swr";
import { IEirSalesAscertain } from "../interfaces/models/IEirSalesAscertain";
import { getAscertain } from "../apis/getAscertain";
import { getProspectReference } from "@utils/storage";

export const useAscertain = (offerId: number, options: SWRConfiguration = {}) => {
    const prospectReference = getProspectReference();

    return useSWR<IEirSalesAscertain>(prospectReference ? ["useAscertain", prospectReference, offerId] : null, {
        fetcher: () => getAscertain(prospectReference!, offerId),
        shouldRetryOnError: (error) => error.status !== 404,
        revalidateOnFocus: false,
        revalidateIfStale: true,
        revalidateOnMount: true,
        ...options,
    });
};
